export default __webpack_public_path__ + "static/media/ic_attachment_primary.ba8d76be.svg";